import { Row } from "antd";
import { PeriodSelector } from "../../../../../../../components/PeriodSelector";
import { PrintHistoryBtn } from "./PrintHistoryBtn";
import { Dayjs } from "dayjs";
import { useCallback } from "react";
import { Print1098 } from "./Print1098";
import { usePermissions } from "../../../../../../../lib/hooks/usePermissions";
import { ITaxInfo } from "../types";

type HeaderProps = {
  range: [Dayjs, Dayjs];
  accountNumber: number;
  taxInfo: ITaxInfo | null;
  setRange: React.Dispatch<React.SetStateAction<[Dayjs, Dayjs]>>;
};

export const Header = ({
  range,
  accountNumber,
  taxInfo,
  setRange,
}: HeaderProps) => {
  const onPeriodChange = useCallback(
    (dates: [Dayjs, Dayjs]) => setRange(dates),
    [setRange],
  );

  const { hasAccessByController } = usePermissions(
    "ExternalUsersReportGeneration",
  );

  return (
    <Row className="pt-6 d-block">
      <p className="my-0 text-sm title pb-1">
        This balance and/or transaction history is provided for information
        purposes only and should not be used for payoff purposes.
      </p>
      <p className="my-0 text-sm title">
        Please be advised that it may take up to 24 hours to process the
        transaction. All payments will be posted as of the payment effective
        date and not the payment initiation date.
      </p>
      <Row className="align-center justify-space-between mt-4">
        <Row>
          <PeriodSelector range={range} onPeriodChange={onPeriodChange} />
        </Row>
        <Row>
          <PrintHistoryBtn accountNumber={accountNumber} range={range} />
          {hasAccessByController("Report1098") && taxInfo?.isBuyer && (
            <Print1098
              accountNumber={accountNumber}
              taxInfo={taxInfo}
              customClassName="ml-4"
            />
          )}
        </Row>
      </Row>
    </Row>
  );
};
